export const SECTION_ID = {
  WRITE_BOARD: 'write-board',
};
